import { Model } from '@vuex-orm/core';

export default class Price extends Model {
    static entity = 'prices';

    static fields() {
        return {
            id: this.increment(),
            material: this.string(),
            position_id: this.number().nullable(),
            priceType: this.number(),
            price: this.number()
        }
    }
}